'use client';

import { useEffect, useState, type ComponentType } from 'react';

type ThreeBackgroundComponent = ComponentType<Record<string, never>>;

export function ThreeBackgroundLoader() {
	const [ThreeBackground, setThreeBackground] =
		useState<ThreeBackgroundComponent | null>(null);

	useEffect(() => {
		let cancelled = false;
		let idleId: number | null = null;
		let timerId: ReturnType<typeof setTimeout> | null = null;

		const load = () => {
			void import('./ThreeBackground').then((module) => {
				if (!cancelled) setThreeBackground(() => module.ThreeBackground);
			});
		};

		if ('requestIdleCallback' in window) {
			idleId = window.requestIdleCallback(load, { timeout: 1_500 });
		} else {
			timerId = globalThis.setTimeout(load, 900);
		}

		return () => {
			cancelled = true;
			if (idleId !== null) window.cancelIdleCallback(idleId);
			if (timerId !== null) clearTimeout(timerId);
		};
	}, []);

	return ThreeBackground ? <ThreeBackground /> : null;
}
